var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome2.0ffaf35f.png","uri@3x": __webpack_public_path__ + "static/media/welcome2.21c172c8.png","uri@2x": __webpack_public_path__ + "static/media/welcome2.f73f0d0c.png",
    width: 179,
    height: 178
});